export const GET_RESOURCES= 'GET_RESOURCES';
export const GET_RESOURCES_SUCCESS = 'GET_RESOURCES_SUCCESS';
export const GET_RESOURCES_FAILED = 'GET_RESOURCES_FAILED';